/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_ScanningInputs */



/**
* | output |
* | --- |
* | "Scanning..." |
*
* @param {Audio_Embed_Export_ScanningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_scanning = /** @type {((inputs?: Audio_Embed_Export_ScanningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_ScanningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Balayage...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Scanvorgang läuft...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scansione in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сканирование...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exploración...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("扫描...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("走査...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्कैनिंग जारी है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Analisando...")
	return /** @type {LocalizedString} */ ("Scanning...")
});